import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { setData } from "../../core/redux/app/Actions";
import { supabase } from "../../supabaseClient";
import { compareValues } from "../ModalClients/ModalClientsContainer";
import { saveAeProductionPhase } from "../../core/utils/AeProductionPhase";
import Swal from "sweetalert2";
import ModalProductionPhasesAesthetic from "../../screens/ModalProductionPhasesAesthetic/ModalProductionPhasesAesthetic";
import { alertError, alertSuccess } from "../../components/Toast";

const ModalProductionPhasesAestheticContainer = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const params = useParams();
  const isNew = params.id === "0";
  const reloadAeProductionPhase = useSelector(
    (state) => state.app.reloadAeProductionPhase || false
  );
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});
  const [values, setValues] = useState({});
  const [oldValues, setOldValues] = useState({});
  const [subService, setSubService] = useState([]);
  const [oldSubService, setOldSubService] = useState([]);
  const [auxValues, setAuxValues] = useState({});

  const loadData = async () => {
    let { data, error } = await supabase
      .from("AestheticProcSteps")
      .select("*")
      .eq("id", id)
      .is("deleted_at", null);

    if (!error) {
      setValues(data[0]);
      setOldValues(data[0]);
      const subService = JSON.parse(data[0].items);
      setSubService(subService);
      setOldSubService(subService);
    }
  };

  useEffect(() => {
    if (id !== "0") {
      loadData();
    }
  }, [id]);

  const addChecklistItem = () => {
    if (auxValues && auxValues.description) {
      setSubService((values) =>
        values.concat([{ ...auxValues, id: Math.random() }])
      );
      setAuxValues({ description: "" });
    }
  };

  const onDeleteChecklistItem = (item) => {
    setSubService((values) => values.filter((row) => row.id !== item.id));
  };

  const closeModal = () => {
    if (
      compareValues(oldValues, values) ||
      compareValues(oldSubService, subService)
    ) {
      Swal.fire({
        title: "Deseja sair sem salvar?",
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        icon: "warning",
        text: "Ao sair, seus dados serão descartados.",
        denyButtonText: `Sair`,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isDenied) {
          history.push("/aesthetic");
        }
      });
    } else {
      history.push("/aesthetic");
    }
  };

  const onChange = (field, value) => {
    if (field == "number") {
      setSubService((services) =>
        services?.map((item) =>
          item.id === value.id ? { ...item, ...value } : { ...item }
        )
      );
    } else {
      setValues((values) => ({ ...values, [field]: value }));
    }
  };

  const onSave = async () => {
    try {
      if (values && !values.title) {
        alertError("É obrigatório colocar um título");
        return;
      }

      if (subService.length <= 0 && !subService) {
        alertError("É obrigatório ter pelo menos um item da lista adicionado");
        return;
      }

      await saveAeProductionPhase(values.id, {
        title: values.title,
        index: values.index,
        items: JSON.stringify(subService),
        id_company: company.id,
      });
      alertSuccess("Sucesso ao salvar a lista!");
      history.push("/aesthetic");
      dispatch(setData({ reloadAeProductionPhase: !reloadAeProductionPhase }));
    } catch (error) {
      alertError("Erro ao salvar a lista, tente novamente mais tarde.");
    }
  };

  const onRemove = async () => {
    const confirmation = await Swal.fire({
      title: "Deseja mesmo excluir?",
      showCancelButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      icon: "warning",
      text: "Seus dados serão completamente perdidos!",
      denyButtonText: "Excluir",
      cancelButtonText: "Cancelar",
    });

    if (confirmation.isDenied) {
      if (values && values.id) {
        const { data, error } = await supabase
          .from("AestheticProcSteps")
          .update({ deleted_at: new Date(), deleted_by: user.id })
          .eq("id", values.id);

        if (!error) {
          alertSuccess("Removido com sucesso!");
          history.push("/aesthetic");
          dispatch(setData({ reloadAeProductionPhase: !reloadAeProductionPhase }));
        } else {
          alertError("Erro ao remover, tente novamente mais tarde");
        }
      } else {
        alertError("Erro ao remover, tente novamente mais tarde");
      }
    } else {
      history.push("/aesthetic");
    }
  };

  return (
    <ModalProductionPhasesAesthetic
      compareValues={
        compareValues(oldValues, values) ||
        compareValues(oldSubService, subService)
      }
      closeModal={closeModal}
      onChange={onChange}
      values={values}
      isNew={isNew}
      onDeleteChecklistItem={onDeleteChecklistItem}
      addChecklistItem={addChecklistItem}
      subService={subService}
      setValues={setValues}
      onSave={onSave}
      setAuxValues={setAuxValues}
      auxValues={auxValues}
      onRemove={onRemove}
    />
  );
};

export default ModalProductionPhasesAestheticContainer;
